import React, { useState, useEffect } from 'react'
import { Card, Container } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Form, Schema } from 'rsuite';
import Information from '../../../../Shared/Card/Information';
import Swal from 'sweetalert2';
import cpdRequirementsService from '../../../../../services/Internal/Renewal/PLS/cpdRequirements.service';
import renewalService from '../../../../../services/Internal/Renewal/renewal.service';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons'
import { GetRenewalInformationContent } from '../../../../Shared/InformationContent/PlsInformation';
import Courses from './Courses'
import entityService from '../../../../../services/Internal/Staff/entity.service';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import Issues from '../../../../Shared/Card/Issues';
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function CpdRequirementsPage() {
    const push = useNavigate();
    const [isComplete, isCompleteCallBack] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [isRequired, setIsRequired] = useState(true);
    const [isNonActiveToActive, setIsNonActiveToActive] = useState(false);
    const [isLicenseStatusSet, setIsLicenseStatusSet] = useState(true);
    const [hasLoaded, setHasLoaded] = useState(false);
    const renewalId = useSelector(x => x.currentApplicationId);
    const [sectionData, setSectionData] = useState({});
    const entityId = useSelector(x => x.userInfo.EntityId)
    const sectionId = 3;
    const routes = useSelector(x => x.currentRoutes);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Professional Land Surveyor Renewal",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "CPD Requirements"
        }
    );
    const changeLogData = {
        Header: "CPD Change History",
        BodyText: "The information below displays all changes made to the CPD section. It allows our staff to track any irregularities and find process breakdowns so that we can make improvements to our system.",
        CurrentId: renewalId,
        SectionId: sectionId
    };
    const currentDate = new Date();
    var yearBase = (currentDate.getMonth() == 0 && currentDate.getDate() < 30) ? currentDate.getFullYear() - 1 : currentDate.getFullYear(); //LAPELS-379
    const [formModel, setFormModel] = useState({
        id: 0,
        renewalId: renewalId,
        entityId: entityId,
        year1: (yearBase - 2),
        year1Hours: null,
        year2: (yearBase - 1),
        year2Hours: null,
        metCpd: null,
        notMetCPDReason: null,
        carryoverExplanation: "",
        userCrte: "",
        dateCrte: new Date(),
        deleted: false,
        hasCpdInMyNcees: null,
        electronicSignature: "",
    });
    useEffect(() => {
        cpdRequirementsService.isNonActiveToActive(renewalId).then((response) => {
            if (response.data) {
                setIsNonActiveToActive(true);
            }
        })
        renewalService.plsGetSection(renewalId, sectionId).then((response) => {
            setSectionData(response.data);
            isCompleteCallBack(response.data.staffReviewComplete);
            renewalService.getIndividualRenewal(renewalId).then((data) => {
                setIsUserEditable(data.data.status.id == 2)
                entityService.getEntity(response.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: data.data?.credential?.formattedLicenseNumber,
                            applicationDate: data.data?.dateSubmitted
                        })
                });
            });

            cpdRequirementsService.isCpdRequired(renewalId).then((result) => {//if result is null, no status was chosen
                if (result.data) {
                    cpdRequirementsService.getCpdRequirements(renewalId).then((data) => {
                        if (data.data) {
                            setFormModel({ ...data.data, electronicSignature: response.data.electronicSignature })
                        }
                        setHasLoaded(true);
                    })
                }
                else if (result.data === false) {
                    setIsRequired(false)
                    setHasLoaded(true)
                }
                else {
                    setIsLicenseStatusSet(false)
                    setHasLoaded(true)
                }
            })
        })
    }, [])

    const { StringType, BooleanType, NumberType, ObjectType } = Schema.Types;
    const model = Schema.Model({
        electronicSignature: StringType().when(schema => {
            return !isNonActiveToActive ? StringType().isRequired('This field is required.') : StringType();
        }),
        metCpd: BooleanType().when(schema => {
            return !isNonActiveToActive ? BooleanType().isRequired('This field is required.') : BooleanType()
        }),
        notMetCPDReason: ObjectType().when(schema => {
            var { value } = schema.metCpd;
            return !isNonActiveToActive && value === false ? ObjectType().isRequired('This field is required.') : ObjectType();
        }),
        hasCpdInMyNcees: BooleanType().when(schema => {
            return isNonActiveToActive ? BooleanType().isRequired('This field is required.') : BooleanType();
        }),
    });

    const formSubmit = (validation, event) => {
        var hasErrors = false;
        var validationObject = model.check(formModel);
        for (const key in validationObject) {
            if (validationObject[key].hasError) {
                if (!isNonActiveToActive) {
                    if (key === "electronicSignature") {
                        hasErrors = true;
                        return
                    }
                    if (key === "metCpd" && formModel.metCpd === null) {
                        hasErrors = true;
                        return
                    }
                    if (key === "notMetCPDReason" && formModel.metCpd === false) {
                        hasErrors = true;
                        return
                    }
                }
                else {
                    if (key === "hasCpdInMyNcees" && formModel.hasCpdInMyNcees === null) {
                        hasErrors = true;
                        return;
                    }
                }
            }
        }
        if (!hasErrors) {
            var dataToTransmit = { ...formModel, year1Hours: formModel.year1Hours === '' ? null : formModel.year1Hours, year2Hours: formModel.year2Hours === '' ? null : formModel.year2Hours };
            renewalService.plsPostSection(renewalId, sectionId, formModel.electronicSignature).then((data) => {
                cpdRequirementsService.postCpdRequirements(dataToTransmit).then((response) => {
                    if (response.data.id) {
                        if (data.data) {
                            renewalService.plsMarkSectionComplete(renewalId, sectionId, isComplete).then((data) => {
                                nextSectionNavigation();
                            })
                        }
                    }
                })
            })
        }
    }
    const notRequiredSubmit = (event) => {
        renewalService.plsMarkSectionComplete(renewalId, sectionId, isComplete).then((data) => {
            nextSectionNavigation();
        })
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
    }
    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Information content={GetRenewalInformationContent("cpdRequirements")} />
                <br />{hasLoaded ? !isLicenseStatusSet ?
                    <Form onSubmit={notRequiredSubmit}>
                        <Card>
                            <Card.Header>
                                <h5>CPD Requirements</h5>
                            </Card.Header>
                            <Card.Body>
                                <span>Please go back and choose a license status to renew into before completing this section. You may access that section by clicking the "Back to Sections" button at the bottom of the page.</span>
                            </Card.Body>
                        </Card>
                        <br />
                        <Issues isUserEditable={isUserEditable} type={3} sectionId={sectionData.id} changeLog={changeLogData} />
                        <FormActionButtons nextSectionCallback={nextSectionNavigation} isUserEditable={isUserEditable} backToSectionLink="/individual/plsRenewal/sections" />
                    </Form>
                    : isRequired ?
                        <Form model={model} formValue={formModel} onChange={formModel => setFormModel(formModel)} onSubmit={formSubmit} fluid>
                            <Courses
                                isReadOnly={!isUserEditable}
                                year1Number={formModel.year1}
                                year2Number={formModel.year2}
                                hasCpdInMyNcees={formModel.hasCpdInMyNcees}
                                metCpd={formModel.metCpd}
                                isNonActiveToActive={isNonActiveToActive}
                                sectionId={sectionData.id}
                                entityId={formModel.entityId}
                            />
                            <br />
                            <Issues isUserEditable={isUserEditable} isInternal={true} type={3} sectionId={sectionData.id} setIsComplete={isCompleteCallBack} changeLog={changeLogData} />
                            <FormActionButtons
                                nextSectionCallback={nextSectionNavigation}
                                isUserEditable={isUserEditable}
                                isComplete={isComplete} isCompleteCallback={isCompleteCallBack}
                                showSectionComplete={true} backToSectionLink="/internal/plsRenewal/sections" />
                        </Form> :
                        <Form onSubmit={notRequiredSubmit}>
                            <Card>
                                <Card.Header>
                                    <h5>CPD Requirements</h5>
                                </Card.Header>
                                <Card.Body>
                                    <span>Due to the license status chosen at the beginning of this renewal, this section is not required. You may click "Next Section" to continue your renewal.</span>
                                </Card.Body>
                            </Card>
                            <br />
                            <Issues isUserEditable={isUserEditable} isInternal={true} type={3} sectionId={sectionData.id} setIsComplete={isCompleteCallBack} changeLog={changeLogData} />
                            <FormActionButtons
                                nextSectionCallback={nextSectionNavigation}
                                isUserEditable={isUserEditable}
                                isComplete={isComplete} isCompleteCallback={isCompleteCallBack}
                                showSectionComplete={true} backToSectionLink="/internal/plsRenewal/sections" />
                        </Form> : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}

export default CpdRequirementsPage